module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_05.f6b2ff11.png";